import { getSupaClient } from "./supabase";

/**
 * Check if user has admin access. Admin key env var needs to be set and user session needs to
 * contain the right admin key.
 * @returns
 */
export const checkAccess = () => {
  const supabase = getSupaClient();
  const session = supabase.auth.session();

  if (process.env["REACT_APP_ADMIN_KEY"]) {
    if (session?.user?.app_metadata["adminKey"]) {
      return (
        session.user.app_metadata["adminKey"] ===
        process.env["REACT_APP_ADMIN_KEY"]
      );
    }
    return false;
  }
  return false;
};
